import { ICategoriaActivo } from 'modelos/src';

/**
 * Ruta al detalle de una entidad según su tipo (los de `EntidadesSchema` en
 * modelos, más los que usan las asignaciones de SIMs). Devuelve undefined si
 * el tipo no tiene pantalla de detalle por ruta: el chofer no tiene detalle.
 *
 * Para 'Activo' la pantalla depende de la categoría: un activo de categoría
 * Vehículo o Colectivo tiene su propio detalle.
 */
export function rutaDetalleEntidad(
  tipo: string | undefined,
  id: string | undefined,
  categoriaActivo?: ICategoriaActivo,
): string[] | undefined {
  if (!tipo || !id) return undefined;
  switch (tipo) {
    case 'Tracker':
      return ['/main', 'administracion', 'trackers', 'detallesTracker', id];
    case 'Dashcam':
      return ['/main', 'administracion', 'dashcams', 'detalles', id];
    case 'Alarma':
      return ['/main', 'alarmas', 'alarmasDomiciliarias', 'detallesAlarma', id];
    case 'SIM':
      return ['/main', 'administracion', 'sims', id];
    case 'Luminaria':
      return ['/main', 'luminarias', 'luminarias', 'detalles', id];
    case 'Dispositivo Lorawan':
      return ['/main', 'administracion', 'dispositivoslorawan', 'detalles', id];
    case 'Vehículo':
      return ['/main', 'vehiculos', 'vehiculos', 'detalles', id];
    case 'Colectivo':
      return ['/main', 'colectivos', 'colectivos', 'detalles', id];
    case 'Sirena':
      return ['/main', 'sirenas', 'sirenas', 'detalles', id];
    case 'Activo':
      if (categoriaActivo === 'Vehículo') {
        return ['/main', 'vehiculos', 'vehiculos', 'detalles', id];
      }
      if (categoriaActivo === 'Colectivo') {
        return ['/main', 'colectivos', 'colectivos', 'detalles', id];
      }
      return ['/main', 'activos', 'activos', 'detalles', id];
    default:
      return undefined;
  }
}
